import { render, staticRenderFns } from "./ContentRelatedObjective.vue?vue&type=template&id=869dfd28&scoped=true"
import script from "./ContentRelatedObjective.vue?vue&type=script&lang=js"
export * from "./ContentRelatedObjective.vue?vue&type=script&lang=js"
import style0 from "./ContentRelatedObjective.vue?vue&type=style&index=0&id=869dfd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869dfd28",
  null
  
)

export default component.exports